if (!customElements.get('wlsn-use-case-tabs')) {
  class WLSNUseCaseTabs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        tabTrigger: 'js-tab-trigger',
        tabContent: 'js-tab-content',
        tabTitleMobile: 'wlsn-use-case-tabs__tab-title--mobile',
        active: 'active',
      };

      this.bind = {
        onRootClick: this._onRootClick.bind(this),
      };
    }

    /**
     * Returns tab triggers and content panels scoped under this element.
     *
     * @returns {{
     *   tabTriggers: NodeListOf<HTMLElement>;
     *   tabContents: NodeListOf<HTMLElement>;
     * }}
     */
    get elements() {
      return {
        tabTriggers: this.querySelectorAll(`.${this.classes.tabTrigger}`),
        tabContents: this.querySelectorAll(`.${this.classes.tabContent}`),
      };
    }

    /**
     * Delegates clicks from tab triggers and syncs active panels by shared tab id.
     *
     * @returns {void}
     */
    connectedCallback() {
      this.addEventListener('click', this.bind.onRootClick);
    }

    /**
     * Removes the delegated click listener.
     *
     * @returns {void}
     */
    disconnectedCallback() {
      this.removeEventListener('click', this.bind.onRootClick);
    }

    /**
     * Activates the tab matching `data-tab-trigger-id` and shows the panel with the same `data-tab-content-id`.
     *
     * @param {MouseEvent} event - Click from inside this component.
     * @returns {void}
     */
    _onRootClick(event) {
      /** @type {HTMLElement | null} */
      const trigger = event.target.closest(`.${this.classes.tabTrigger}`);
      if (!trigger || !this.contains(trigger)) return;

      const tabId = trigger.getAttribute('data-tab-trigger-id');
      if (!tabId) return;

      this._setActiveState(tabId, this.elements);
    }

    _setActiveState(tabId, elements) {
      const { tabTriggers, tabContents } = elements;
      tabTriggers.forEach(trigger => {
        trigger.classList.toggle(this.classes.active, trigger.getAttribute('data-tab-trigger-id') === tabId);
      });

      tabContents.forEach(content => {
        content.classList.toggle(this.classes.active, content.getAttribute('data-tab-content-id') === tabId);
      });
    }
  }

  customElements.define('wlsn-use-case-tabs', WLSNUseCaseTabs);
}
